import { entitlementsService } from '@saucelabs/sl-util-axios';

export const getOrgEntitlements = ({ uuid }) => (
  entitlementsService.get(`/entities/org/${uuid}`)
);
